import { render, staticRenderFns } from "./user-meage.vue?vue&type=template&id=6d4bcfca&scoped=true&"
import script from "./user-meage.vue?vue&type=script&lang=js&"
export * from "./user-meage.vue?vue&type=script&lang=js&"
import style0 from "./user-meage.vue?vue&type=style&index=0&id=6d4bcfca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bcfca",
  null
  
)

export default component.exports